export default __webpack_public_path__ + "static/media/heroeg.625f430c.png";